import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

const PrivateRoute = ({ component: Component, ...rest }) => {
    const { isAuthenticated, user } = useSelector((state) => state.auth);
    const location = useLocation()
    return (
        <>
            <Route
                {...rest}
                render={(props) => {
                    if (isAuthenticated && isAuthenticated === true) {
                        if (location.search) {
                            //TODO Ask to kamlesh
                            // return <Redirect to={location.search.split('=')[1]} />
                        }
                        if (user?.userType === 'admin' || user?.userType === 'subadmin') {
                            return <Redirect to='/admin/dashboard' />
                        }
                      }else {
                        return <Redirect to='/login' />
                      }
                      return <Component {...props} />;

                }}
            />
        </>
    );
};

export default PrivateRoute
